export default function makeIsTableResizing(store) {
  return {
    isTableResizing: function isTableResizing(editor, tableId) {
      var _ref = store.getItem(tableId) || {},
          resizingColumn = _ref.resizingColumn;

      return resizingColumn !== undefined;
    }
  };
}